import * as React from "react";
import {Modal} from "../../Modal";
import Button from "../../Button";
import './PreviewSeedProductModal.css';
import MarkdownRenderer from '../../Editor/components/CropPageView/common/MarkdownRenderer'
import {connect} from "react-redux";
import TypeSeed from '../../Products/TypeSeed'
import { changeZoom } from '../../../actions/actions';

export interface PreviewSeedProductProps {
    show: any;
    onClose: any;
    product: any;
    resetZoom?(type: string): void;
}

export interface PreviewSeedProductState {
}

const mapDispatchToProps = (dispatch: any): any => {
    return {
      resetZoom: (type: string) => {
        dispatch(changeZoom(type));
      },
    };
  };
  

const mapStateToProps = (state: any): any => {
    return {
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class PreviewSeedProductModal extends React.Component<PreviewSeedProductProps, PreviewSeedProductState> {
    constructor(props: PreviewSeedProductProps) {
        super(props);
        this.resetZoom();
    }

    resetZoom() {
        if (this.props.resetZoom) {
            this.props.resetZoom('reset');   
        }
    }

    closeModal = () => this.setState({ showModal: false});

    render() {

        var wrapperContainerClass = "previewCatalogWrapperContainer";
        var subWrapperContainerClass = "previewCatalogSubWrapperContainer";

        if (this.props.product.type.toUpperCase() == "SEED") {
            wrapperContainerClass = "previewSixPerPageWrapperContainer"
            subWrapperContainerClass = "previewSixPerPageSubWrapperContainer";
        }


        return (
            <Modal show={this.props.show}
                   onClose={this.props.onClose}
                   className="extra-large-modal"
            >
                <Modal.Header>
                    <MarkdownRenderer
                        markdown={this.props.product.name}
                        className={"previewProductTitle"} />
                    <Button bsClass="close" onClick={this.props.onClose}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className={wrapperContainerClass}>
                        <div className={subWrapperContainerClass}>
                            <div className="previewSeedProductContainer">
                                <TypeSeed product={this.props.product}
                                    pageNumber={1} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={this.props.onClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/PreviewSeedProductModal/PreviewSeedProductModal.tsx